/**
 * Global link redirect configuration
 * 
 * This file contains the global redirect rules that will be applied
 * to all <a> tags throughout the application when using LinkInterceptor.
 */

export interface RedirectRule {
  pattern: string | RegExp;
  target: string;
  exact?: boolean;
}

export interface GlobalRedirects {
  [externalUrl: string]: string;
}

// Global redirect rules for pattern matching
export const GLOBAL_REDIRECT_RULES: RedirectRule[] = [
  // Example patterns - customize these for your app
  // Uncomment and modify these examples for your specific needs:
  
  // Redirect profile links to internal user pages
  // { pattern: /^https:\/\/yourapp\.com\/profile\/(.+)$/, target: '/home/user/$1' },
  
  // Redirect event links to internal event pages
  // { pattern: /^https:\/\/yourapp\.com\/events\/(.+)$/, target: '/home/event/$1' },
  
  // Redirect group chat links
  // { pattern: /^https:\/\/yourapp\.com\/chat\/group\/(.+)$/, target: '/home/group/$1' },
  
  // Redirect specific dashboard URL
  // { pattern: 'https://yourapp.com/dashboard', target: '/home', exact: true },
  
  // Redirect orangepill.app.link URLs to transaction details with branch URL
  { pattern: /^https:\/\/orangepill\.app\.link\/(.+)$/, target: '/home/chat/?branch_url_link=https://orangepill.app.link/$1' },

  { pattern: /^http:\/\/orangepill\.app\.link\/(.+)$/, target: '/home/chat/?branch_url_link=https://orangepill.app.link/$1' },
  
  // Redirect public.orangepillapp.com/event/xxx to specific event page
  { pattern: /^https:\/\/public\.orangepillapp\.com\/event\/(.+)$/, target: '/home/search/event/$1' },
  { pattern: /^https:\/\/public\.cluborange\.org\/event\/(.+)$/, target: '/home/search/event/$1' },

  { pattern: /^http:\/\/app.orangepillapp.com\/(.+)$/, target: '/home/chat/?short_link=$1' },
  { pattern: /^http:\/\/app.cluborange.org\/(.+)$/, target: '/home/chat/?short_link=$1' },
  { pattern: /^https:\/\/app.orangepillapp.com\/(.+)$/, target: '/home/chat/?short_link=$1' },
  { pattern: /^https:\/\/app.cluborange.org\/(.+)$/, target: '/home/chat/?short_link=$1' },
];

// Global exact URL redirects
export const GLOBAL_EXACT_REDIRECTS: GlobalRedirects = {
  // Example exact redirects - customize these for your app
  // Uncomment and modify these examples for your specific needs:
  
  // 'https://yourapp.com/profile': '/home/profile',
  // 'https://yourapp.com/settings': '/home/settings',
  // 'https://yourapp.com/wallet': '/home/wallet',
};

// Helper function to get all redirect rules
export const getAllRedirectRules = () => ({
  rules: GLOBAL_REDIRECT_RULES,
  exact: GLOBAL_EXACT_REDIRECTS,
});
